/* eslint-disable */
import * as R from 'ramda';
import { createGlobalStyle } from 'styled-components';
//////////////////////////////////////////////////

const GlobalStyle = createGlobalStyle`
  * {
    box-sizing: border-box;
  }
  *::-webkit-scrollbar-track {
    background-color: transparent;
  }
  *::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }
  *::-webkit-scrollbar-thumb {
    border-radius: 5px;
    background-color: ${R.pathOr('#b1b1b1', ['theme', 'colors', 'light', 'darkGrey'])};
  }
  /* "react-google-maps" */
  .gm-style button.gm-control-active * {
    box-sizing: unset;
  }
  .gm-style .gmnoprint * {
    box-sizing: unset;
  }
  // leaflet
  .leaflet-marker-inner:hover {
    transform: scale(1.1);
  }
  .leaflet-marker-inner::after {
    top: 26px;
    right: 50%;
    content: '';
    position: absolute;
    transform: translateX(50%);
    border: 13px solid transparent;
    border-top: 18px solid #2073a1;
    -webkit-transform: translateX(50%);
  }
  .leaflet-marker-inner.selected::after {
    border-top: 18px solid #b1b1b1;
  }
  .leaflet-marker-inner.greenColor::after {
    border-top: 18px solid #1d9206;
  }
  .leaflet-control-container .leaflet-routing-container-hide {
    display: none;
  }
  // toastr
  .redux-toastr .top-left {
    left: 55px;
  }
  & #root-portal > div > div > div.react-datepicker-popper {
      z-index: 1301;
      position: relative;
  }
`;

export default GlobalStyle;
/* eslint-enable */
